// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.food_to_go {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.food_to_go .products__section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 74vh;
}
.food_to_go .products__section .products__btns {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 80%;
  margin: 0 auto;
}
.food_to_go .products__section .products__btns button {
  --b: 3px; /* border thickness */
  --s: 0.15em; /* size of the corner */
  padding: calc(0.05em + var(--s)) calc(0.3em + var(--s));
  color: #2c53a0;
  --_p: var(--s);
  background: conic-gradient(from 90deg at var(--b) var(--b), rgba(0, 0, 0, 0) 90deg, #2c53a0 0) var(--_p) var(--_p)/calc(100% - var(--b) - 2 * var(--_p)) calc(100% - var(--b) - 2 * var(--_p));
  transition: 0.3s linear, color 0s, background-color 0s;
  outline: var(--b) solid rgba(0, 0, 0, 0);
  outline-offset: 0.2em;
  font-weight: 800;
  font-size: 3rem;
  cursor: pointer;
  border: none;
  margin: 0.1em;
}
.food_to_go .products__section .products__btns button:hover,
.food_to_go .products__section .products__btns button :focus-visible {
  --_p: 0px;
  outline-color: #2c53a0;
  outline-offset: 0.05em;
}
.food_to_go .products__section .products__btns button:active {
  background: var(--c);
  color: #fff;
}
.food_to_go .products__section .add_prod_form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 95%;
  margin: 0 auto;
  color: #4d4d4d;
}
.food_to_go .products__section .add_prod_form .form__wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 50%;
  margin: 5% auto;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form label {
  color: #4d4d4d;
  font-size: 1.2rem;
  margin-top: 2%;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form label span {
  color: #bb0000;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form label:first-of-type {
  margin-top: 0;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form input,
.food_to_go .products__section .add_prod_form .form__wrapper .form select {
  border: 1px solid #2c53a0;
  width: 50%;
  height: 2rem;
  border-radius: 0.5rem;
  background-color: #fff;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form #add_prod_btn {
  margin-top: 3%;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form .form_row {
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 80%;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form .form_row .row__column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 25%;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form table {
  width: 100%;
  margin-top: 2%;
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form table tbody {
  text-align: center;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.food_to_go .products__section .add_prod_form .form__wrapper .form textarea {
  border: 1px solid #2c53a0;
  border-radius: 1rem;
}
.food_to_go .products__section .add_prod_form .form__wrapper .allergens__selection {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}
.food_to_go .products__section .add_prod_form .form__wrapper .allergens__selection .allergen__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 14%;
}
.food_to_go .products__section .add_prod_form .form__wrapper .allergens__selection .allergen__row input[type=checkbox] {
  height: 1rem;
  width: 1rem;
}
.food_to_go .products__section .add_prod_form .form__wrapper .allergens__selection .allergen__row label {
  font-size: 1rem;
}
.food_to_go .products__section .add_prod_form #add_prod_btn {
  margin-left: 40vw;
}
.food_to_go .products__section .add_prod_form input,
.food_to_go .products__section .add_prod_form select {
  border: 1px solid #2c53a0;
  width: 50%;
  height: 2rem;
  border-radius: 0.5rem;
  background-color: #fff;
}
.food_to_go .products__section .add_prod_form .modify__select {
  margin: 1% 0 0 12vw;
}
.food_to_go .products__section .add_prod_form .modify__product {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: #4d4d4d;
  width: 60vw;
  margin: 0 auto;
}
.food_to_go .products__section .add_prod_form .modify__product .modify_row {
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 100%;
  flex-wrap: wrap;
}
.food_to_go .products__section .add_prod_form .modify__product .modify_row p span {
  color: #2c53a0;
}
.food_to_go .products__section .add_prod_form .modify__product .modify_row #category,
.food_to_go .products__section .add_prod_form .modify__product .modify_row #cost,
.food_to_go .products__section .add_prod_form .modify__product .modify_row #price,
.food_to_go .products__section .add_prod_form .modify__product .modify_row #volumeOfSale,
.food_to_go .products__section .add_prod_form .modify__product .modify_row #ingredients,
.food_to_go .products__section .add_prod_form .modify__product .modify_row #description {
  display: none;
  width: 20%;
}
.food_to_go .products__section .add_prod_form .modify__product .modify_row #useBy {
  display: none;
  align-items: center;
  justify-content: flex-start;
}
.food_to_go .products__section .add_prod_form .modify__product .modify_row #useBy .useby__column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.food_to_go .products__section .add_prod_form .modify__product table {
  width: 100%;
  margin-top: 2%;
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
}
.food_to_go .products__section .add_prod_form .modify__product table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
.food_to_go .products__section .add_prod_form .modify__product table tbody {
  text-align: center;
}
.food_to_go .products__section .add_prod_form .modify__product table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
.food_to_go .products__section .add_prod_form .modify__product table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
.food_to_go .products__section .add_prod_form .modify__product table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
.food_to_go .products__section .add_prod_form .modify__product .allergens__selection {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}
.food_to_go .products__section .add_prod_form .modify__product .allergens__selection .allergen__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 14%;
}
.food_to_go .products__section .add_prod_form .modify__product .allergens__selection .allergen__row input[type=checkbox] {
  height: 1rem;
  width: 1rem;
}
.food_to_go .products__section .add_prod_form .modify__product .allergens__selection .allergen__row label {
  font-size: 1rem;
}
@media (max-width: 600px) {
  .food_to_go .products__section {
    overflow-x: hidden;
  }
  .food_to_go .products__section .products__btns {
    flex-wrap: wrap;
  }
  .food_to_go .products__section .products__btns button {
    --b: 2px;
    font-size: 1.5rem;
    margin-bottom: 2%;
  }
  .food_to_go .products__section .add_prod_form {
    width: 90%;
  }
  .food_to_go .products__section .add_prod_form input,
  .food_to_go .products__section .add_prod_form select {
    width: 100%;
  }
  .food_to_go .products__section .add_prod_form .form_row {
    width: 100%;
  }
  .food_to_go .products__section .add_prod_form table {
    width: 90vw;
    margin: 2% 0 1% -5%;
  }
  .food_to_go .products__section .add_prod_form .modify__product {
    width: 98vw;
  }
  .food_to_go .products__section .add_prod_form .modify__product .modify_row #category,
  .food_to_go .products__section .add_prod_form .modify__product .modify_row #cost,
  .food_to_go .products__section .add_prod_form .modify__product .modify_row #price {
    width: 40%;
  }
}

.sato__main {
  min-height: 74vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.sato__main .download__btn {
  display: flex;
  align-items: center;
  font-family: inherit;
  font-weight: 500;
  font-size: 17px;
  padding: 0.8em 1.5em 0.8em 1.2em;
  color: white;
  background: #2c53a0;
  background: linear-gradient(0deg, #2c53a0 0%, #64c4e0 100%);
  border: none;
  box-shadow: 0 0.7em 1.5em -0.5em #2c53a0;
  letter-spacing: 0.05em;
  border-radius: 20em;
}
.sato__main .download__btn .btn_icon {
  margin-right: 8px;
}
.sato__main .download__btn:hover {
  box-shadow: 0 0.5em 1.5em -0.5em #2c53a0;
}
.sato__main .download__btn:active {
  box-shadow: 0 0.3em 1em -0.5em #2c53a0;
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/FTG/styles/products.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EDkEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AC7DJ;AANE;EDgEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ECjEA,gBAAA;AAWJ;AAVI;EDiFA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EClFE,UAAA;EACA,cAAA;AAeN;AAdM;EACE,QAAA,EAAA,qBAAA;EACA,WAAA,EAAA,uBAAA;EACA,uDAAA;EACA,cDfI;ECgBJ,cAAA;EACA,8LAAA;EAOA,sDAAA;EACA,wCAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;AAUR;AATQ;;EAEE,SAAA;EACA,sBDnCE;ECoCF,sBAAA;AAWV;AATQ;EACE,oBAAA;EACA,WAAA;AAWV;AAPI;ED8BA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EC/BE,UAAA;EACA,cAAA;EACA,cD7CM;ACyDZ;AAXM;EDgFF,aAAA;EACA,mBAAA;EACA,2BAAA;EChFI,WAAA;AAeR;AAdQ;EDsBJ,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;ECvBM,UAAA;EACA,eAAA;AAmBV;AAlBU;EACE,cDtDA;ECuDA,iBAAA;EACA,cAAA;AAoBZ;AAnBY;EACE,cDzDN;AC8ER;AAnBY;EACE,aAAA;AAqBd;AAlBU;;EAEE,yBAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;AAoBZ;AAlBU;EACE,cAAA;AAoBZ;AAlBU;EDiBN,aAAA;EACA,uBAAA;EACA,6BAAA;ECjBQ,UAAA;AAsBZ;AArBY;EDPR,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;ECMU,UAAA;AA0Bd;AAvBU;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cDzFA;ACkHZ;AAxBY;EACE,gCAAA;EACA,kBAAA;AA0Bd;AAxBY;EACE,kBAAA;AA0Bd;AAzBc;EACE,gCAAA;AA2BhB;AA1BgB;EACE,yBAAA;AA4BlB;AA1BgB;EACE,UAAA;EACA,cAAA;EACA,kBAAA;AA4BlB;AAvBU;EACE,yBAAA;EACA,mBAAA;AAyBZ;AAtBQ;ED7BJ,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EC4BM,eAAA;EACA,WAAA;AA2BV;AA1BU;ED1BN,aAAA;EACA,uBAAA;EACA,6BAAA;EC0BQ,UAAA;AA8BZ;AA7BY;EACE,YAAA;EACA,WAAA;AA+Bd;AA7BY;EACE,eAAA;AA+Bd;AA1BM;EACE,iBAAA;AA4BR;AA1BM;;EAEE,yBAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;AA4BR;AA1BM;EACE,mBAAA;AA4BR;AA1BM;ED1EF,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;ECyEI,cDnJI;ECoJJ,WAAA;EACA,cAAA;AA+BR;AA9BQ;ED1DJ,aAAA;EACA,uBAAA;EACA,6BAAA;EC0DM,WAAA;EACA,eAAA;AAkCV;AAhCY;EACE,cD/JF;ACiMZ;AA/BU;;;;;;EAOE,aAAA;EACA,UAAA;AAgCZ;AA9BU;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAgCZ;AA/BY;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AAiCd;AA7BQ;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cD3LE;AC0NZ;AA9BU;EACE,gCAAA;EACA,kBAAA;AAgCZ;AA9BU;EACE,kBAAA;AAgCZ;AA/BY;EACE,gCAAA;AAiCd;AAhCc;EACE,yBAAA;AAkChB;AAhCc;EACE,UAAA;EACA,cAAA;EACA,kBAAA;AAkChB;AA7BQ;ED1HJ,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;ECyHM,eAAA;EACA,WAAA;AAkCV;AAjCU;EDvHN,aAAA;EACA,uBAAA;EACA,6BAAA;ECuHQ,UAAA;AAqCZ;AApCY;EACE,YAAA;EACA,WAAA;AAsCd;AApCY;EACE,eAAA;AAsCd;AA/BE;EACE;IACE,kBAAA;EAiCJ;EAhCI;IACE,eAAA;EAkCN;EAjCM;IACE,QAAA;IACA,iBAAA;IACA,iBAAA;EAmCR;EAhCI;IACE,UAAA;EAkCN;EAjCM;;IAEE,WAAA;EAmCR;EAjCM;IACE,WAAA;EAmCR;EAjCM;IACE,WAAA;IACA,mBAAA;EAmCR;EAjCM;IACE,WAAA;EAmCR;EAjCU;;;IAGE,UAAA;EAmCZ;AACF;;AA3BA;EACE,gBAAA;EDzME,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ACwOJ;AAhCE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,mBDvRQ;ECwRR,2DAAA;EACA,YAAA;EACA,wCAAA;EACA,sBAAA;EACA,mBAAA;AAkCJ;AAjCI;EACE,iBAAA;AAmCN;AAjCI;EACE,wCAAA;AAmCN;AAjCI;EACE,sCAAA;AAmCN","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../variables.scss\";\n\n.food_to_go {\n  @include columnStart;\n  .products__section {\n    @include columnStart;\n    min-height: 74vh;\n    .products__btns {\n      @include rowEven;\n      width: 80%;\n      margin: 0 auto;\n      button {\n        --b: 3px; /* border thickness */\n        --s: 0.15em; /* size of the corner */\n        padding: calc(0.05em + var(--s)) calc(0.3em + var(--s));\n        color: $nitroDark;\n        --_p: var(--s);\n        background: conic-gradient(\n            from 90deg at var(--b) var(--b),\n            #0000 90deg,\n            $nitroDark 0\n          )\n          var(--_p) var(--_p) / calc(100% - var(--b) - 2 * var(--_p))\n          calc(100% - var(--b) - 2 * var(--_p));\n        transition: 0.3s linear, color 0s, background-color 0s;\n        outline: var(--b) solid #0000;\n        outline-offset: 0.2em;\n        font-weight: 800;\n        font-size: 3rem;\n        cursor: pointer;\n        border: none;\n        margin: 0.1em;\n        &:hover,\n        :focus-visible {\n          --_p: 0px;\n          outline-color: $nitroDark;\n          outline-offset: 0.05em;\n        }\n        &:active {\n          background: var(--c);\n          color: #fff;\n        }\n      }\n    }\n    .add_prod_form {\n      @include columnAlignStart;\n      width: 95%;\n      margin: 0 auto;\n      color: $fontColor;\n      .form__wrapper {\n        @include rowStart;\n        width: 100%;\n        .form {\n          @include columnAlignStart;\n          width: 50%;\n          margin: 5% auto;\n          label {\n            color: $fontColor;\n            font-size: 1.2rem;\n            margin-top: 2%;\n            span {\n              color: $error;\n            }\n            &:first-of-type {\n              margin-top: 0;\n            }\n          }\n          input,\n          select {\n            border: 1px solid $nitroDark;\n            width: 50%;\n            height: 2rem;\n            border-radius: 0.5rem;\n            background-color: #fff;\n          }\n          #add_prod_btn {\n            margin-top: 3%;\n          }\n          .form_row {\n            @include rowEvenStart;\n            width: 80%;\n            .row__column {\n              @include columnAlignStart;\n              width: 25%;\n            }\n          }\n          table {\n            width: 100%;\n            margin-top: 2%;\n            table-layout: fixed;\n            background-color: #fff;\n            border-collapse: collapse;\n            color: $fontColor;\n            thead {\n              border-bottom: 1px solid $fontColor;\n              text-align: center;\n            }\n            tbody {\n              text-align: center;\n              tr {\n                border-bottom: 1px solid $fontColor;\n                &:nth-child(odd) {\n                  background-color: #f2f2f2;\n                }\n                input {\n                  width: 20%;\n                  margin: 0 auto;\n                  text-align: center;\n                }\n              }\n            }\n          }\n          textarea{\n            border: 1px solid $nitroDark;\n            border-radius: 1rem;\n          }\n        }\n        .allergens__selection {\n          @include rowEven;\n          flex-wrap: wrap;\n          width: 100%;\n          .allergen__row {\n            @include rowEvenStart;\n            width: 14%;\n            input[type=\"checkbox\"] {\n              height: 1rem;\n              width: 1rem;\n            }\n            label {\n              font-size: 1rem;\n            }\n          }\n        }\n      }\n      #add_prod_btn {\n        margin-left: 40vw;\n      }\n      input,\n      select {\n        border: 1px solid $nitroDark;\n        width: 50%;\n        height: 2rem;\n        border-radius: 0.5rem;\n        background-color: #fff;\n      }\n      .modify__select{\n        margin: 1% 0 0 12vw;\n      }\n      .modify__product {\n        @include columnAlignStart;\n        color: $fontColor;\n        width: 60vw;\n        margin: 0 auto;\n        .modify_row {\n          @include rowEvenStart;\n          width: 100%;\n          flex-wrap: wrap;\n          p {\n            span {\n              color: $nitroDark;\n            }\n          }\n          #category,\n          #cost,\n          #price,\n          #volumeOfSale,\n          #ingredients,\n          #description\n          {\n            display: none;\n            width: 20%;\n          }\n          #useBy{\n            display: none;\n            align-items: center;\n            justify-content: flex-start;\n            .useby__column{\n              display: flex;\n              flex-direction: column;\n              align-items: flex-start;\n              justify-content: flex-start;\n            }\n          }\n        }\n        table {\n          width: 100%;\n          margin-top: 2%;\n          table-layout: fixed;\n          background-color: #fff;\n          border-collapse: collapse;\n          color: $fontColor;\n          thead {\n            border-bottom: 1px solid $fontColor;\n            text-align: center;\n          }\n          tbody {\n            text-align: center;\n            tr {\n              border-bottom: 1px solid $fontColor;\n              &:nth-child(odd) {\n                background-color: #f2f2f2;\n              }\n              input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n              }\n            }\n          }\n        }\n        .allergens__selection {\n          @include rowEven;\n          flex-wrap: wrap;\n          width: 100%;\n          .allergen__row {\n            @include rowEvenStart;\n            width: 14%;\n            input[type=\"checkbox\"] {\n              height: 1rem;\n              width: 1rem;\n            }\n            label {\n              font-size: 1rem;\n            }\n          }\n        }\n      }\n    }\n  }\n  @media (max-width: $mobile) {\n    .products__section {\n      overflow-x: hidden;\n      .products__btns {\n        flex-wrap: wrap;\n        button {\n          --b: 2px;\n          font-size: 1.5rem;\n          margin-bottom: 2%;\n        }\n      }\n      .add_prod_form {\n        width: 90%;\n        input,\n        select {\n          width: 100%;\n        }\n        .form_row {\n          width: 100%;\n        }\n        table {\n          width: 90vw;\n          margin: 2% 0 1% -5%;\n        }\n        .modify__product {\n          width: 98vw;\n          .modify_row {\n            #category,\n            #cost,\n            #price {\n              width: 40%;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.sato__main {\n  min-height: 74vh;\n  @include columnStart;\n  .download__btn {\n    display: flex;\n    align-items: center;\n    font-family: inherit;\n    font-weight: 500;\n    font-size: 17px;\n    padding: 0.8em 1.5em 0.8em 1.2em;\n    color: white;\n    background: $nitroDark;\n    background: linear-gradient(0deg, $nitroDark 0%, $nitroLight 100%);\n    border: none;\n    box-shadow: 0 0.7em 1.5em -0.5em $nitroDark;\n    letter-spacing: 0.05em;\n    border-radius: 20em;\n    .btn_icon {\n      margin-right: 8px;\n    }\n    &:hover {\n      box-shadow: 0 0.5em 1.5em -0.5em $nitroDark;\n    }\n    &:active {\n      box-shadow: 0 0.3em 1em -0.5em $nitroDark;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
